

















































# import settings from '@/settings'
import absences_table from '@/components/tables/absences_table'
import balance from '@/components/balance'
import m from '@/graphql/mutation'
import q from '@/graphql/query'
import n from '@/utils/notifications'
import t from '@/utils/tools'

export default {
    name: 'company_absences'

    components: { absences_table, balance }

    data: ()->
        refuse_dialog_visible: false
        accept_dialog_visible: false
        reload: false
        absence: {
            uid: ''
            user_uid: ''
            user_in_charge_uid: ''
            absence_type: {uid: '', label: ''}
            start: ''
            end: ''
            nb_days: 0
            state: {uid: ''}
            reason: ''
        }
        errors: {}
        accept_can_save: false
        app_users: []
        selected_user: ''
        valid_text: {
            title: ''
            resume: ''
            confirm: ''
        }
        refuse_text: ''

    computed:
        duration_unity: ()->
            hours_required = ["Repos compensateur obligatoire", "Repos compensateur de remplacement", "Repos compensateur complémentaire"]
            unity = 'jour(s)'
            # console.log "DURATION"
            if @absence.absence_type.label in hours_required
                unity = 'heure(s)'
            return unity

    methods:
        has_access_right: t.has_access_right
        date_formatter: t.date_formatter

        new_balance: ()->
            @reload = !@reload
            return

        valid_text_factory: (old_state_slug)->
            # console.log "VALID TEXT ", old_state_slug
            ret = {
                title: "Validation d'une demande d'absence"
                resume: "la demande"
                confirm: "la demande"
            }
            if old_state_slug == 'annulation_demandee'
                ret = {
                    title: "Annulation d'une absence"
                    resume: "l'absence"
                    confirm: "l'annulation"
                }
            @valid_text = ret
            return

        refuse_text_factory: (old_state_slug)->
            # console.log "REFUSE TEXT ", old_state_slug
            ret = "d'une demande d'absence"
            if old_state_slug == 'annulation_demandee'
                ret = "d'une annulation"
            @refuse_text = ret
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        refuse_open_confirm: (absence, old_state_slug)->
            @refuse_dialog_visible = true
            @absence = absence
            @refuse_text_factory(old_state_slug)
            # console.log 'REFUSE OPEN CONFIRM'
            return

        accept_open_confirm: (absence, old_state_slug)->
            @accept_dialog_visible = true
            @absence = absence
            @valid_text_factory(old_state_slug)
            # console.log 'ACCEPT OPEN CONFIRM'
            return

        refuse_cancel: ()->
            @refuse_dialog_visible = false
            @reload = !@reload
            @errors = {}
            # console.log 'REFUSE CANCEL'
            return

        accept_cancel: ()->
            @accept_dialog_visible = false
            @reload = !@reload
            @errors = {}
            # console.log 'ACCEPT CANCEL'
            return

        pre_save: ()->
            @save(@absence)
            return

        save: (absence)->
            # console.log "SAVE ABSENCE", absence
            self = @
            m.run('save_absence', [absence, 'company'])
            .then (resp)->
                if resp.body.data.absence_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.absence_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.absence_form_mutation.errors
                    self.errors = resp.body.data.absence_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.refuse_dialog_visible = false
                    self.accept_dialog_visible = false
                    self.absence = {
                        uid: ''
                        user_uid: ''
                        user_in_charge_uid: ''
                        absence_type: {uid: '', label: ''}
                        start: ''
                        end: ''
                        nb_days: 0
                        state: {uid: ''}
                        reason: ''
                    }
                    self.reload = !self.reload
                    # console.log "ABSENCE SAVED END ", self.selected_user
                    # console.log "ABSENCE SAVED END ", self.absence
            .catch (resp)->
                n.catch_error(resp, "company_absences: save()")

        get_app_users: ()->
            self = @
            q.run('get_app_user_set', [@$store.getters.current_company.uid, 'absence'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_absences: get_app_users: then", e.message)
                else
                    # console.log "GET APP USERS : ", resp.body.data.app_user_set
                    if resp.body.data.app_user_set.length > 0
                        self.app_users = resp.body.data.app_user_set
                        self.selected_user = resp.body.data.app_user_set[0]['uid']
            .catch (resp)->
                n.catch_error(resp, "company_absences: get_app_users()")
            return

    beforeMount: ()->
        # console.log "COMPANY ABSENCE "
        @get_app_users()
}
